import * as url from "./utils/url"

const tianlongImgMSDKShare =
  "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"
import tianLongIndexBanner from "../../../ui/20180706kanjia_p/ossweb-img/banner.jpg"
import cfIndexBanner from "../../../ui/a20181107CFkanjia/ossweb-img/banner.png"
import cfOpenBanner from "../../../ui/a20181107CFkanjia/ossweb-img/ad.jpg"

import nba2k2IndexBanner from "../../../ui/20190318bargain_p_nba2kol2/ossweb-img/banner.png"
import nba2k2OpenBanner from "../../../ui/20190318bargain_p_nba2kol2/ossweb-img/ad.jpg"

import zyhxIndexBanner from "../../../ui/20190326bargain_p_zyhx/ossweb-img/banner.jpg"
import zyhxOpenBanner from "../../../ui/20190326bargain_p_zyhx/ossweb-img/ad.jpg"
import zyhxCoinIcon from "../../../ui/20190326bargain_p_zyhx/ossweb-img/money-icon.png"

import hldIndexBanner from "../../../ui/20180914bargainp/ossweb-img/img1.jpg"
import hdlOpenBanner from "../../../ui/20180914bargainp/ossweb-img/img2.jpg"
import qqfcIndexBanner from "../../../ui/a20180920kjhdp_speedm/ossweb-img/banner.jpg"
import qqfcOpenBanner from "../../../ui/a20180920kjhdp_speedm/ossweb-img/ad.png"

import cfmIndexBanner from "../../../ui/20181106cfmkanjia_p/ossweb-img/banner.jpg"
import cfmOpenBanner from "../../../ui/20181106cfmkanjia_p/ossweb-img/ad.jpg"

import hjolIndexBanner from "../../../ui/20190315bargain_p_hjol/ossweb-img/banner.jpg"
import hjolOpenBanner from "../../../ui/20190315bargain_p_hjol/ossweb-img/ad.jpg"

import qjjxIndexBanner from "../../../ui/20181206bargain_p_qjjx/ossweb-img/banner.jpg"
import qjjxOpenBanner from "../../../ui/20181206bargain_p_qjjx/ossweb-img/ad.jpg"

import hyolIndexBanner from "../../../ui/20181206bargain_p_hyrzol/ossweb-img/banner.jpg"
import hyolOpenBanner from "../../../ui/20181206bargain_p_hyrzol/ossweb-img/ad.jpg"

import ttkpIndexBanner from "../../../ui/20181206bargain_p_ttkp/ossweb-img/banner.jpg"
import ttkpOpenBanner from "../../../ui/20181206bargain_p_ttkp/ossweb-img/ad.jpg"

import lswzIndexBanner from "../../../ui/20181206bargain_p_lswz/ossweb-img/banner.jpg"
import lswzOpenBanner from "../../../ui/20181206bargain_p_lswz/ossweb-img/ad.jpg"

import sdsIndexBanner from "../../../ui/20181206bargain_p_sds/ossweb-img/banner.jpg"
import sdsOpenBanner from "../../../ui/20181206bargain_p_sds/ossweb-img/ad.jpg"

import dpcqIndexBanner from "../../../ui/20181207bargain_p_dp/ossweb-img/banner.png"
import dpcqOpenBanner from "../../../ui/20181207bargain_p_dp/ossweb-img/ad.jpg"

import shihunIndexBanner from "../../../ui/20190716bargain_p_shihun/ossweb-img/banner.jpg"
import shihunOpenBanner from "../../../ui/20190716bargain_p_shihun/ossweb-img/ad.jpg"
import shihunMoneyIcon from "../../../ui/20190716bargain_p_shihun/ossweb-img/money-icon.png"

import mt4IndexBanner from "../../../ui/20190123bargain_p_mt4/ossweb-img/banner.png"
import mt4OpenBanner from "../../../ui/20190123bargain_p_mt4/ossweb-img/ad.jpg"

import ylztIndexBanner from "../../../ui/20190128bargain_p_yulongzaitian/ossweb-img/banner.png"
import ylztpenBanner from "../../../ui/20190128bargain_p_yulongzaitian/ossweb-img/ad.jpg"

export const CHECK_TYPE = {
  NO_CHECK: 1,
  CHECK_HAS_ROLE: 2,
  NEED_SELECT_ROLE: 3
}
export const GAME_TYPE = {
  PC_GAME: 1,
  MOBILE_GAME: 2
}

const info = {
  "1450000766": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/tlbb_server_select_utf8.js",
    ZONE_KEY: "TLBBServerSelect",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE
  },
  "1450013862": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/tlbb_server_select_utf8.js",
    ZONE_KEY: "TLBBServerSelect",
    itemTitle: "天龙八部手游砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    GAME_SCHEMA: "http://tlbb.qq.com/d/index_hd.htm",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: tianLongIndexBanner,
    BARGAIN_DESCRIPTION: "手起刀落，一起砍价畅游江湖吧！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.shtml",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    QRCODE_DISPLAY: 0,
    RULE: `<li><b>活动时间：</b>即日起至8月19日</li>
              <li><b>砍价怎么玩？</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。</li>
                  <li style="list-style-type: lower-alpha;">每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具。</li>
                  <li style="list-style-type: lower-alpha;">发起人：同一用户最多可发起20次砍价，但每个道具限发起5次砍价。</li>
                  <li style="list-style-type: lower-alpha;">帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍10次。</li>
                  <li style="list-style-type: lower-alpha;">每次砍价金额随机，参与好友越多越容易砍到最低价。</li>
                </ul>
              </li>
              <li><b>温馨提示</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格。</li>
                  <li style="list-style-type: lower-alpha;">支付完成后，一般立即发货（如遇大活动可能有延时），可留意天龙八部游戏内道具通知邮件</li>
                  <li style="list-style-type: lower-alpha;">请关注<b>“腾讯充值”</b>公众号，砍价成功消息提醒将通过该公众号通知。</li>
                </ul>
              </li>`
  },
  "1450016335": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/cf_server_select_utf8.js",
    ZONE_KEY: "CFServerSelect",
    itemTitle: "CF端游砍价活动",
    CHECK_TYPE: CHECK_TYPE.CHECK_HAS_ROLE,
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: cfIndexBanner,
    OPEN_BANNER: cfOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.PC_GAME,
    RULE: `<li><b>活动时间：</b>即日起至2018年9月16日</li>
              <li><b>砍价怎么玩？</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。</li>
                  <li style="list-style-type: lower-alpha;">每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具。</li>
                  <li style="list-style-type: lower-alpha;">发起人：同一用户最多可发起5次砍价，若多次选择同一道具，每个道具限发起5次砍价。</li>
                  <li style="list-style-type: lower-alpha;">帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次</li>
                  <li style="list-style-type: lower-alpha;">每次砍价金额随机，参与好友越多越容易砍到最低价。</li>
                </ul>
              </li>
              <li><b>温馨提示</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格</li>
                  <li style="list-style-type: lower-alpha;">支付完成后，一般立即发货（如遇大活动可能有延时），可留意CF游戏内道具通知邮件</li>
                  <li style="list-style-type: lower-alpha;">请关注<b>“腾讯充值”</b>公众号，砍价成功消息提醒将通过该公众号通知。</li>
                </ul>
              </li>`
  },
  "1450016333": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/ffom_server_select_utf8.js",
    ZONE_KEY: "FFOMServerSelect",
    itemTitle: "自由幻想砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    GAME_SCHEMA: "https://zyhx.qq.com/act/a20180814pintuan/index.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: zyhxIndexBanner,
    OPEN_BANNER: zyhxOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "自由砍价，一减到底",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    RULE: `
                <li><strong>活动时间：</strong>即日起至2018年10月15日</li>
                <li>
                    <strong>砍价怎么玩？</strong>
                    <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。
                    <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具
                    <br>（3）发起人：每个道具限发起3次砍价（英伦情歌男/女 各限发起砍价1次）
                    <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍10次
                    <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>
                <li>
                    <strong>温馨提示</strong>
                    <br>（1）砍价购买道具均为绑定道具（不可摆摊，不可赠送）
                    <br>（2）支付完成后，一般立即发货（如遇大活动可能有延时），可留意自由幻想游戏内道具通知邮件
                    <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>
            `,
    BARGAIN_GROUP: "KANJ190321222227318",
    GAME_COIN_PAY: {
      IOS: {
        OFFERID: "1450020264",
        BARGAIN_GROUP: "KANJ190401151750453"
      },
      ANDROID: {
        OFFERID: "1450016333",
        BARGAIN_GROUP: "KANJ190321222227318"
      }
    },
    GAME_COIN_PAY_IOS_OFFERID: "1450020264",
    GAME_COIN_PAY_IOS_BARGAIN_GROUP: "KANJ190401151750453",
    GAME_COIN_NAME: "幻想币",
    GAME_COIN_RATE: 10,
    GAME_COIN_ICON: zyhxCoinIcon,
    DISABLE_IOS_USER: 0
  },
  "1450020264": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/ffom_server_select_utf8.js",
    ZONE_KEY: "FFOMServerSelect",
    itemTitle: "自由幻想砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    GAME_SCHEMA: "https://zyhx.qq.com/act/a20180814pintuan/index.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: zyhxIndexBanner,
    OPEN_BANNER: zyhxOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "自由砍价，一减到底",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    RULE: `
                <li><strong>活动时间：</strong>即日起至2018年10月15日</li>
                <li>
                    <strong>砍价怎么玩？</strong>
                    <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。
                    <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具
                    <br>（3）发起人：每个道具限发起3次砍价（英伦情歌男/女 各限发起砍价1次）
                    <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍10次
                    <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>
                <li>
                    <strong>温馨提示</strong>
                    <br>（1）砍价购买道具均为绑定道具（不可摆摊，不可赠送）
                    <br>（2）支付完成后，一般立即发货（如遇大活动可能有延时），可留意自由幻想游戏内道具通知邮件
                    <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>
            `,
    BARGAIN_GROUP: "KANJ190401151750453",
    FIRST_BARGAIN_MSG: "邀请好友来帮砍，再砍一刀就到底价！",
    GAME_COIN_NAME: "幻想币",
    HAS_COIN_CHANNEL: true,
    GAME_COIN_RATE: 10,
    GAME_RECHARGE_URL: "https://pay.qq.com/h5/store/index.shtml?pf=xxx#/order/283/biz/291",
    GAME_COIN_ICON: zyhxCoinIcon,
    DISABLE_IOS_USER: 0
  },
  "1450014615": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/hdl_server_select_utf8.js",
    ZONE_KEY: "HDLServerSelect",
    itemTitle: "魂斗罗手游砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    GAME_SCHEMA: "http://hdl.qq.com/d/a201814cz/index.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    GAME_COIN_NAME: "钻石",
    GAME_COIN_RATE: 10,
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: hldIndexBanner,
    OPEN_BANNER: hdlOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    RULE: `
                 <li><strong>当前活动暂不支持抢先服玩家参与</strong></li>
                <li><strong>活动时间：</strong>即日起至2018年10月15日</li>

                <li>
                    <strong>砍价怎么玩？</strong>
                    <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。
                    <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具
                    <br>（3）发起人：每个道具限发起1次砍价（橙色装备万能碎片可发起5次砍价）
                    <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍10次
                    <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>
                <li>
                    <strong>温馨提示</strong>
                    <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格
                    <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待
                    <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>
            `,
    BARGAIN_GROUP: "KANJ190719203557288"
  },
  "1450015040": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/speedm_server_select_utf8.js",
    ZONE_KEY: "SPEEDMServerSelect",
    itemTitle: "QQ飞车手游砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    GAME_SCHEMA: "https://speedm.qq.com/d/a20180212lester/play.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: qqfcIndexBanner,
    OPEN_BANNER: qqfcOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    BARGAIN_GROUP: "KANJ190723121650626",
    GAME_COIN_NAME: "钻石",
    GAME_COIN_RATE: 10,
    GAME_COIN_ICON: shihunMoneyIcon,
    RULE: `<li>
            <strong>活动时间：</strong>即日起至2018年10月14日</li>                 <li>                     <strong>砍价怎么玩？</strong>                     <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。                     <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具                     <br>（3）发起人：同一用户最多可发起6次砍价，每个道具限发起1次砍价                     <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次                     <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>                 <li>                     <strong>温馨提示</strong>                     <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格                     <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待                     <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>  `
  },
  "1450016332": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/speedm_server_select_utf8.js",
    ZONE_KEY: "SPEEDMServerSelect",
    itemTitle: "CFM手游砍价活动",
    CHECK_TYPE: CHECK_TYPE.NO_CHECK,
    GAME_SCHEMA: "https://speedm.qq.com/d/a20180212lester/play.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: cfmIndexBanner,
    OPEN_BANNER: cfmOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    RULE:
      "<li> <strong>活动时间：</strong>即日起至2018年10月14日</li>                 <li>                     <strong>砍价怎么玩？</strong>                     <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。                     <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具                     <br>（3）发起人：同一用户最多可发起6次砍价，每个道具限发起1次砍价                     <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次                     <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>                 <li>                     <strong>温馨提示</strong>                     <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格                     <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待                     <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>  "
  },
  "1450018303": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/hongjing_server_select_utf8.js",
    ZONE_KEY: "HONGJINGServerSelect",
    itemTitle: "红色警戒OL手游砍价活动",
    CHECK_TYPE: CHECK_TYPE.CHECK_HAS_ROLE,
    GAME_SCHEMA: "https://speedm.qq.com/d/a20180212lester/play.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: hjolIndexBanner,
    OPEN_BANNER: hjolOpenBanner,
    BARGAIN_GROUP: "KANJ190315150311816",
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    RULE:
      "<li> <strong>活动时间：</strong>即日起至2018年10月14日</li>                 <li>                     <strong>砍价怎么玩？</strong>                     <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。                     <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具                     <br>（3）发起人：同一用户最多可发起6次砍价，每个道具限发起1次砍价                     <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次                     <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>                 <li>                     <strong>温馨提示</strong>                     <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格                     <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待                     <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>  "
  },
  "1450018778": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/qjjx_server_select_utf8.js",
    ZONE_KEY: "QJJXServerSelect",
    itemTitle: "奇迹觉醒手游砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    GAME_SCHEMA: "https://speedm.qq.com/d/a20180212lester/play.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: qjjxIndexBanner,
    OPEN_BANNER: qjjxOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    RULE:
      "<li> <strong>活动时间：</strong>即日起至2018年10月14日</li>                 <li>                     <strong>砍价怎么玩？</strong>                     <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。                     <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具                     <br>（3）发起人：同一用户最多可发起6次砍价，每个道具限发起1次砍价                     <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次                     <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>                 <li>                     <strong>温馨提示</strong>                     <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格                     <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待                     <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>  "
  },
  "1450018793": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/hyrzol_server_select_utf8.js",
    ZONE_KEY: "HYRZOLServerSelect",
    itemTitle: "火影OL手游砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    GAME_SCHEMA: "https://speedm.qq.com/d/a20180212lester/play.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: hyolIndexBanner,
    OPEN_BANNER: hyolOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    RULE:
      "<li> <strong>活动时间：</strong>即日起至2018年10月14日</li>                 <li>                     <strong>砍价怎么玩？</strong>                     <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。                     <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具                     <br>（3）发起人：同一用户最多可发起6次砍价，每个道具限发起1次砍价                     <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次                     <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>                 <li>                     <strong>温馨提示</strong>                     <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格                     <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待                     <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>  "
  },
  "1450018792": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/hyrzol_server_select_utf8.js",
    ZONE_KEY: "HYRZOLServerSelect",
    itemTitle: "天天酷跑手游砍价活动",
    CHECK_TYPE: CHECK_TYPE.NO_CHECK,
    GAME_SCHEMA: "https://speedm.qq.com/d/a20180212lester/play.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: ttkpIndexBanner,
    OPEN_BANNER: ttkpOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    RULE:
      "<li> <strong>活动时间：</strong>即日起至2018年10月14日</li>                 <li>                     <strong>砍价怎么玩？</strong>                     <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。                     <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具                     <br>（3）发起人：同一用户最多可发起6次砍价，每个道具限发起1次砍价                     <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次                     <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>                 <li>                     <strong>温馨提示</strong>                     <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格                     <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待                     <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>  "
  },
  "1450018724": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/slg_server_select_utf8.js",
    ZONE_KEY: "SLGServerSelect",
    itemTitle: "乱世王者手游砍价活动",
    CHECK_TYPE: CHECK_TYPE.CHECK_HAS_ROLE,
    GAME_SCHEMA: "https://speedm.qq.com/d/a20180212lester/play.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: lswzIndexBanner,
    OPEN_BANNER: lswzOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    RULE:
      "<li> <strong>活动时间：</strong>即日起至2018年10月14日</li>                 <li>                     <strong>砍价怎么玩？</strong>                     <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。                     <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具                     <br>（3）发起人：同一用户最多可发起6次砍价，每个道具限发起1次砍价                     <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次                     <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>                 <li>                     <strong>温馨提示</strong>                     <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格                     <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待                     <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>  "
  },
  "1450017517": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/seiya_server_select_utf8.js",
    ZONE_KEY: "SEIYAServerSelect",
    itemTitle: "圣斗士星矢手游砍价活动",
    CHECK_TYPE: CHECK_TYPE.CHECK_HAS_ROLE,
    GAME_SCHEMA: "https://speedm.qq.com/d/a20180212lester/play.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: sdsIndexBanner,
    OPEN_BANNER: sdsOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    RULE:
      "<li> <strong>活动时间：</strong>即日起至2018年10月14日</li>                 <li>                     <strong>砍价怎么玩？</strong>                     <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。                     <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具                     <br>（3）发起人：同一用户最多可发起6次砍价，每个道具限发起1次砍价                     <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次                     <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>                 <li>                     <strong>温馨提示</strong>                     <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格                     <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待                     <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>  "
  },
  "1450018731": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/dp_server_select_utf8.js",
    ZONE_KEY: "DPServerSelect",
    itemTitle: "斗破苍穹手游砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    GAME_SCHEMA: "https://speedm.qq.com/d/a20180212lester/play.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: dpcqIndexBanner,
    OPEN_BANNER: dpcqOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    RULE:
      "<li> <strong>活动时间：</strong>即日起至2018年10月14日</li>                 <li>                     <strong>砍价怎么玩？</strong>                     <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。                     <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具                     <br>（3）发起人：同一用户最多可发起6次砍价，每个道具限发起1次砍价                     <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次                     <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>                 <li>                     <strong>温馨提示</strong>                     <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格                     <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待                     <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>  "
  },
  "1450019111": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/shihun_server_select_utf8.js",
    ZONE_KEY: "SHIHUNServerSelect",
    itemTitle: "侍魂-胧月传说砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    GAME_SCHEMA: "https://speedm.qq.com/d/a20180212lester/play.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: shihunIndexBanner,
    OPEN_BANNER: shihunOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    BARGAIN_GROUP: "KANJ190715223252812",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    GAME_COIN_NAME: "勾玉",
    GAME_COIN_RATE: 10,
    GAME_COIN_ICON: shihunMoneyIcon,
    RULE:
      "<li> <strong>活动时间：</strong>即日起至2018年10月14日</li>                 <li>                     <strong>砍价怎么玩？</strong>                     <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。                     <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具                     <br>（3）发起人：同一用户最多可发起6次砍价，每个道具限发起1次砍价                     <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次                     <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>                 <li>                     <strong>温馨提示</strong>                     <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格                     <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待                     <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>  "
  },
  "1450018727": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/mt4_server_select_utf8.js",
    ZONE_KEY: "MT4ServerSelect",
    itemTitle: "我叫MT4砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    GAME_SCHEMA: "https://speedm.qq.com/d/a20180212lester/play.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: mt4IndexBanner,
    OPEN_BANNER: mt4OpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    BARGAIN_GROUP: "KANJ190123143058720",
    RULE:
      "<li> <strong>活动时间：</strong>即日起至2018年10月14日</li>                 <li>                     <strong>砍价怎么玩？</strong>                     <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。                     <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具                     <br>（3）发起人：同一用户最多可发起6次砍价，每个道具限发起1次砍价                     <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次                     <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>                 <li>                     <strong>温馨提示</strong>                     <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格                     <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待                     <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>  "
  },
  "1450018728": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/ylzt_server_select_utf8.js",
    ZONE_KEY: "YLZTServerSelect",
    itemTitle: "御龙在天手游砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    GAME_SCHEMA: "https://speedm.qq.com/d/a20180212lester/play.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: ylztIndexBanner,
    OPEN_BANNER: ylztpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    BARGAIN_GROUP: "KANJ190123162432392",
    RULE:
      "<li> <strong>活动时间：</strong>即日起至2018年10月14日</li>                 <li>                     <strong>砍价怎么玩？</strong>                     <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。                     <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具                     <br>（3）发起人：同一用户最多可发起6次砍价，每个道具限发起1次砍价                     <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次                     <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>                 <li>                     <strong>温馨提示</strong>                     <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格                     <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待                     <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>  "
  },
  "1450020113": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/nba2k2_server_select_utf8.js",
    ZONE_KEY: "CFServerSelect",
    itemTitle: "NBA2K ONLINE2砍价活动",
    CHECK_TYPE: CHECK_TYPE.NO_CHECK,
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: nba2k2IndexBanner,
    OPEN_BANNER: nba2k2OpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.PC_GAME,
    BARGAIN_GROUP: "KANJ191213161001364",
    RULE: `<li><b>活动时间：</b>即日起至2018年9月16日</li>
              <li><b>砍价怎么玩？</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。</li>
                  <li style="list-style-type: lower-alpha;">每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具。</li>
                  <li style="list-style-type: lower-alpha;">发起人：同一用户最多可发起5次砍价，若多次选择同一道具，每个道具限发起5次砍价。</li>
                  <li style="list-style-type: lower-alpha;">帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次</li>
                  <li style="list-style-type: lower-alpha;">每次砍价金额随机，参与好友越多越容易砍到最低价。</li>
                </ul>
              </li>
              <li><b>温馨提示</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格</li>
                  <li style="list-style-type: lower-alpha;">支付完成后，一般立即发货（如遇大活动可能有延时），可留意CF游戏内道具通知邮件</li>
                  <li style="list-style-type: lower-alpha;">请关注<b>“腾讯充值”</b>公众号，砍价成功消息提醒将通过该公众号通知。</li>
                </ul>
              </li>`
  },
  "1450020948": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/wuxia_server_select_utf8.js",
    ZONE_KEY: "WUXIAServerSelect",
    itemTitle: "NBA2K ONLINE2砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: nba2k2IndexBanner,
    OPEN_BANNER: nba2k2OpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.PC_GAME,
    BARGAIN_GROUP: "KANJ190523150226057",
    RULE: `<li><b>活动时间：</b>即日起至2018年9月16日</li>
              <li><b>砍价怎么玩？</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。</li>
                  <li style="list-style-type: lower-alpha;">每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具。</li>
                  <li style="list-style-type: lower-alpha;">发起人：同一用户最多可发起5次砍价，若多次选择同一道具，每个道具限发起5次砍价。</li>
                  <li style="list-style-type: lower-alpha;">帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次</li>
                  <li style="list-style-type: lower-alpha;">每次砍价金额随机，参与好友越多越容易砍到最低价。</li>
                </ul>
              </li>
              <li><b>温馨提示</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格</li>
                  <li style="list-style-type: lower-alpha;">支付完成后，一般立即发货（如遇大活动可能有延时），可留意CF游戏内道具通知邮件</li>
                  <li style="list-style-type: lower-alpha;">请关注<b>“腾讯充值”</b>公众号，砍价成功消息提醒将通过该公众号通知。</li>
                </ul>
              </li>`
  },
  "1450020986": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/age_server_select_utf8.js",
    ZONE_KEY: "AGEServerSelect",
    itemTitle: "上古世纪砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: nba2k2IndexBanner,
    OPEN_BANNER: nba2k2OpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.PC_GAME,
    BARGAIN_GROUP: "KANJ190701151935719",
    RULE: `<li><b>活动时间：</b>即日起至2018年9月16日</li>
              <li><b>砍价怎么玩？</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。</li>
                  <li style="list-style-type: lower-alpha;">每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具。</li>
                  <li style="list-style-type: lower-alpha;">发起人：同一用户最多可发起5次砍价，若多次选择同一道具，每个道具限发起5次砍价。</li>
                  <li style="list-style-type: lower-alpha;">帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次</li>
                  <li style="list-style-type: lower-alpha;">每次砍价金额随机，参与好友越多越容易砍到最低价。</li>
                </ul>
              </li>
              <li><b>温馨提示</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格</li>
                  <li style="list-style-type: lower-alpha;">支付完成后，一般立即发货（如遇大活动可能有延时），可留意CF游戏内道具通知邮件</li>
                  <li style="list-style-type: lower-alpha;">请关注<b>“腾讯充值”</b>公众号，砍价成功消息提醒将通过该公众号通知。</li>
                </ul>
              </li>`
  },
  "1450021258": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/poe_server_select_utf8.js",
    ZONE_KEY: "POEServerSelect",
    itemTitle: "流放之路砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: nba2k2IndexBanner,
    OPEN_BANNER: nba2k2OpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.PC_GAME,
    BARGAIN_GROUP: "KANJ190910180836513",
    RULE: `<li><b>活动时间：</b>即日起至2018年9月16日</li>
              <li><b>砍价怎么玩？</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。</li>
                  <li style="list-style-type: lower-alpha;">每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具。</li>
                  <li style="list-style-type: lower-alpha;">发起人：同一用户最多可发起5次砍价，若多次选择同一道具，每个道具限发起5次砍价。</li>
                  <li style="list-style-type: lower-alpha;">帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次</li>
                  <li style="list-style-type: lower-alpha;">每次砍价金额随机，参与好友越多越容易砍到最低价。</li>
                </ul>
              </li>
              <li><b>温馨提示</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格</li>
                  <li style="list-style-type: lower-alpha;">支付完成后，一般立即发货（如遇大活动可能有延时），可留意CF游戏内道具通知邮件</li>
                  <li style="list-style-type: lower-alpha;">请关注<b>“腾讯充值”</b>公众号，砍价成功消息提醒将通过该公众号通知。</li>
                </ul>
              </li>`
  },
  "1450021423": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/bns_server_select_utf8.js",
    ZONE_KEY: "BNSServerSelect",
    itemTitle: "剑灵砍价活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: nba2k2IndexBanner,
    OPEN_BANNER: nba2k2OpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.PC_GAME,
    BARGAIN_GROUP: "KANJ191126202849702",
    RULE: `<li><b>活动时间：</b>即日起至2018年9月16日</li>
              <li><b>砍价怎么玩？</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。</li>
                  <li style="list-style-type: lower-alpha;">每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具。</li>
                  <li style="list-style-type: lower-alpha;">发起人：同一用户最多可发起5次砍价，若多次选择同一道具，每个道具限发起5次砍价。</li>
                  <li style="list-style-type: lower-alpha;">帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次</li>
                  <li style="list-style-type: lower-alpha;">每次砍价金额随机，参与好友越多越容易砍到最低价。</li>
                </ul>
              </li>
              <li><b>温馨提示</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格</li>
                  <li style="list-style-type: lower-alpha;">支付完成后，一般立即发货（如遇大活动可能有延时），可留意CF游戏内道具通知邮件</li>
                  <li style="list-style-type: lower-alpha;">请关注<b>“腾讯充值”</b>公众号，砍价成功消息提醒将通过该公众号通知。</li>
                </ul>
              </li>`
  },
  "1450021621": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/x52_server_select_utf8.js",
    ZONE_KEY: "X52ServerSelect",
    itemTitle: "炫舞时代活动",
    CHECK_TYPE: CHECK_TYPE.NEED_SELECT_ROLE,
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: nba2k2IndexBanner,
    OPEN_BANNER: nba2k2OpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.PC_GAME,
    BARGAIN_GROUP: "KANJ191023114041426",
    RULE: `<li><b>活动时间：</b>即日起至2018年9月16日</li>
              <li><b>砍价怎么玩？</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。</li>
                  <li style="list-style-type: lower-alpha;">每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具。</li>
                  <li style="list-style-type: lower-alpha;">发起人：同一用户最多可发起5次砍价，若多次选择同一道具，每个道具限发起5次砍价。</li>
                  <li style="list-style-type: lower-alpha;">帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次</li>
                  <li style="list-style-type: lower-alpha;">每次砍价金额随机，参与好友越多越容易砍到最低价。</li>
                </ul>
              </li>
              <li><b>温馨提示</b>
                <ul>
                  <li style="list-style-type: lower-alpha;">砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格</li>
                  <li style="list-style-type: lower-alpha;">支付完成后，一般立即发货（如遇大活动可能有延时），可留意CF游戏内道具通知邮件</li>
                  <li style="list-style-type: lower-alpha;">请关注<b>“腾讯充值”</b>公众号，砍价成功消息提醒将通过该公众号通知。</li>
                </ul>
              </li>`
  },
  "1450013861": {
    ZONE_URL: "//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/ttaxc_server_select_utf8.js",
    ZONE_KEY: "HYRZOLServerSelect",
    itemTitle: "天天爱消除手游砍价活动",
    CHECK_TYPE: CHECK_TYPE.CHECK_HAS_ROLE,
    GAME_SCHEMA: "https://speedm.qq.com/d/a20180212lester/play.html",
    SHARE_ICON: "https://midas.gtimg.cn/h5/bargain/static/images/tlbb_bargain_icon.jpg",
    IMG_MSDK_SHARE_ICON: tianlongImgMSDKShare,
    SHARE_TITLE: "【天龙八部手游】手起刀落，一起砍价畅游江湖吧！",
    SHARE_DESC: "道具低至5元！武侠砍价，刀刀暴击！",
    WECHAT_OPEN_LINK_INDEX: "https://w.url.cn/s/Aw7f07p",
    WECHAT_OPEN_lINK_MY_BARGIN: "https://w.url.cn/s/AnUC2HA",
    INDEX_BANNER: ttkpIndexBanner,
    OPEN_BANNER: ttkpOpenBanner,
    OPEN_BANNER_LINK: "https://cf.qq.com/cp/a20180821new/index.shtml?e_code=435992",
    BARGAIN_DESCRIPTION: "集结兄弟帮砍价，花好月圆火力高！",
    BARGAIN_URL: "https://pay.qq.com/h5/activity/bargain/index.php",
    GAME_TYPE: GAME_TYPE.MOBILE_GAME,
    BARGAIN_GROUP: "KANJ190731172425861",
    GAME_COIN_NAME: "钻石",
    GAME_COIN_RATE: 10,
    GAME_COIN_ICON: shihunMoneyIcon,
    RULE:
      "<li> <strong>活动时间：</strong>即日起至2018年10月14日</li>                 <li>                     <strong>砍价怎么玩？</strong>                     <br>（1）用户可任选道具，发起砍价，在有效期内邀请好友帮忙砍价。                     <br>（2）每个砍价活动有效期<b>2小时</b>，砍价完成后即可用“砍后价”购买道具                     <br>（3）发起人：同一用户最多可发起6次砍价，每个道具限发起1次砍价                     <br>（4）帮砍人：可以帮好友发起的每个活动砍1刀；一共可以帮砍5次                     <br>（5）每次砍价金额随机，参与好友越多越容易砍到最低价</li>                 <li>                     <strong>温馨提示</strong>                     <br>（1）砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格                     <br>（2）支付完成后，道具将以邮件形式发货，请注意查收哦！若因网络原因稍有延迟，请耐心等待                     <br>（3）请关注“<b>腾讯充值</b>”公众号，砍价成功消息提醒将通过该公众号通知</li>  "
  }
}

export const GAME_INFO = window.bargainConfigs && window.bargainConfigs[url.getParam("offerId")] ? window.bargainConfigs : info

export const MQQ_URL = "//pub.idqqimg.com/qqmobile/qqapi.js?_bid=152"

export const REPORT = {
  PAGEVIEW: {
    ACTIVITY_RULE: "pageview.price.rule", //活动规则展示
    ACTIVITY_INDEX: "pageview.price.homepage", //活动商品页面
    BARGAIN_DETAIL: "pageview.price.commodity", //砍价活动页面
    OPENER_FIRST_BARGAIN: "pageview.price.starter_invite_popup", //首砍弹窗
    ZONE_LIST: "pageview.price.list", //大区列表
    OPENER_PAY_VIEW: "pageview.price.result_starter", //发起人显示可以支付
    BARGAIN_HELPER: "pageview.price.process_assistor", //砍价进度人帮砍人
    BARGAIN_HELPER_SUCCESS: "pageview.price.assitor_toast", //帮砍成功toast
    BARGAIN_END_HELPER_VIEW: "pageview.price.assistor_activityend", //活动结束帮砍人进入上报
    BARGAIN_RECORD: "pageview.price.record_record", //我的砍价-有砍价记录
    BARGAIN_NON_RECORD: "pageview.price.record_norecord", //我的砍价-无砍价记录
    BARGAIN_PAY_SUCCESS: "pageview.price.pay.success", //砍价支付成功上报
    BARGAIN_FAIL_EXCEED_SINGLE_PRODUCT_MAXMUM_PROCESSING: "pageview.price.restrict_starter_invite", //超出单商品发起砍价次数&活动进行中
    BARGAIN_FAIL_EXCEED_SINGLE_PRODUCT_MAXMUM_END: "pageview.price.restrict_starter_exceed", //超出单商品发起砍价次数&活动结束
    BARGAIN_FAIL_EXCEED_TOTAL_PRODUCT_MAXMUM_PROCESSING: "pageview.price.restrict_starter_process", //超出总商品发起砍价次数&活动进行中
    BARGAIN_FAIL_EXCEED_TOTAL_PRODUCT_MAXMUM_END: "pageview.price.restrict_starter_end", //超出总商品发起砍价次数&活动结束
    BARGAIN_FAIL_EXCEED_HELP_BARGAIN_MAXMUM: "pageview.price.restrict_assistor_exceed", //超出帮砍次数
    INGAME_BARGAIN_INDEX: "pageview.price.ingame_startpage", //游戏内打开砍价页面
    INGAME_BARGAIN_SHARE: "pageview.price.ingame_share", //游戏内显示分享
    INGAME_BARGAIN_VIEW_OUTSIDE_GAME: "pageview.price.ingame_enter_horizontal", //游戏外非微信和手Q打开游戏内页面上报
    OUTGAME_BARGAIN_NON_WECHAT_AND_QQ: "pageview.price.ingame_enter_vertical"
  },
  CLICK: {
    PRODUCT_DETAIL: "click.price.tab_commodity", //点击砍价商品
    MY_BARGAIN_LIST: "click.price.tab_my", //点击我的砍价
    SHOW_RULE: "click.price.rule", //点击活动规则
    OPEN_BARGAIN: "click.price.start", //点击发起砍价按钮
    FIRST_BARGAIN_DIALOG_CLOSE: "click.price.price_close", //首砍弹窗关闭
    FIRST_BARGAIN_DIALOG_SHARE: "click.price.price_share", //首砍弹窗邀请好友砍一刀
    FIRST_BARGAIN_DETAIL_SHARE: "click.price.starter_process_invite", //发起人点击邀请好友砍一刀
    FIRST_BARGAIN_DETAIL_SWITCH_QQ: "click.price.starter_process_changeqq", //发起人切换qq
    OPENER_SELECT_ZONE: "click.price.starter_process_gamecenter", //发起人点击选择大区
    OPENER_SELECT_ROLE: "click.price.starter_process_gamerole", //发起人点击选择角色
    OPENER_PAY: "click.price.starter_process_now", //发起人点击支付
    RESULT_REOPEN_BARGAIN: "click.price.starter_pay_again", //支付结果页点击再次发起砍价
    RESULT_ENTER_GAME: "click.price.starter_pay_enter", //支付结果页进入游戏
    BARGAIN_HELPER_START: "click.price.assistor_help", //帮砍人点击帮砍按钮
    BARGAIN_HELPER_START_BARGAIN: "click.price.assistor_start", //帮砍人点击我要发起砍价按钮
    BARGAIN_HELPER_ENTER_GAME: "click.price.assistor_enter", //帮砍人点击进入游戏
    OPENER_CONTINUE_BARGAIN: "click.price.price_keep", //发起人在我的砍价列表点击继续砍价
    OPENER_CONTINUE_PAY: "click.price.price_now", //发起人砍价列表点击立即支付
    OPENER_CHECK_MORE_PENDING_BARGAIN: "click.price.price_more_process", //发起人点击查看更多进行中的砍价
    OPENER_CHECK_MORE_UNPAID_BARGAIN: "click.price.price_more_wait", //发气人点击查看更多待支付砍价
    OPENER_CHECK_MORE_PAID_BARGAIN: "click.price.price_more_paid", //发起人点击查看更多已支付按钮
    MYBARGAIN_NO_RECORD_START: "click.price.price_start", //我的砍价无记录场景点击发起砍价按钮
    EXCEED_SINGLE_PRODUCT_MAXMUM_END: "click.price.restrict_return", //商品已结束点击超过单商品砍价次数返回按钮
    EXCEED_SINGLE_PRODUCT_MAXMUM_PENDING: "click.price.restrict_invite", //商品进行中点击超过单商品砍价次数返回按钮
    EXCEED_TOTAL_PRODUCT_MAXMUM_END: "click.price.restrict_verify", //商品已结束超过总商品砍价次数返回
    EXCEED_TOTAL_PRODUCT_MAXMUM_PENDING: "click.price.restrict_history", //商品进行中超过总商品砍价次数返回
    EXCEED_TOTAL_HELP_BARGIN_MAXMUM: "click.price.restrict_start", //超过帮砍次数点击发起砍价妞妞
    INGAME_START_BARGAIN: "click.price.ingame_start", //游戏内页面点击发起砍价
    INGAME_SHARE_WX_TIMELINE: "click.price.ingame_share_moment", //游戏内点击分享朋友圈
    INGAME_SHARE_WX_FRIENDS: "click.price.ingame_share_wechat", //游戏内点击分享微信好友
    INGAME_SHARE_QQ_FRIENDS: "click.price.ingame_share_qq", //游戏内点击分享qq
    INGAME_LAUNCH_QQ: "click.price.ingame_enter_qq", //游戏外场景访问游戏内页面点击去qq
    INGAME_LAUNCH_WX: "click.price.ingame_enter_wechat" //游戏外场景访问游戏内页面点击去微信
  }
}
